import { CancelSaveButtons } from '@components/cancel-save-buttons';
import { createForm, useCreateFormStore } from '@components/form';
import { hideModal, Modal, useModal } from '@components/modal';
import { useScopedTranslate } from '@locale/translate';

import { useDuplicateIntegrationEndpoint } from '../integrations-hooks';
import type { DuplicateEndpointData, IntegrationEndpoint } from '../integrations-types';

export const useDuplicateIntegrationEndpointModal = () =>
  useModal(DuplicateIntegrationEndpointModal);

const Form = createForm<DuplicateEndpointData>();

export const DuplicateIntegrationEndpointModal = ({
  endpoint,
}: {
  endpoint: IntegrationEndpoint<string>;
}) => {
  const { t } = useScopedTranslate(locale);
  const formStore = useCreateFormStore();

  const duplicateMutation = useDuplicateIntegrationEndpoint(endpoint);

  const handleSubmit = async () => {
    await duplicateMutation.mutateAsync(formStore.getState().values as DuplicateEndpointData);
    hideModal();
  };

  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} />
      <Modal.Content>
        <Form store={formStore} onSubmit={handleSubmit}>
          <Form.TextField
            id="name"
            label={t('endpointName')}
            defaultValue={`${endpoint.name} [${t('copy')}]`}
          />
        </Form>
      </Modal.Content>
      <Modal.Footer>
        <CancelSaveButtons
          alwaysShow
          onCancel={hideModal}
          onSave={handleSubmit}
          translationsOverride={{ save: t('confirm') }}
          isDisabled={duplicateMutation.isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};

const locale = {
  en: {
    title: 'Duplicate integration endpoint',
    endpointName: 'Endpoint name',
    copy: 'copy',
    confirm: 'Duplicate',
  },
};
